import { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';

interface IntegracaoExternaRawJsonProps {
  request?: string;
  response?: string;
}

function prettyJson(json: string | undefined): string {
  if (!json) return '—';
  try {
    return JSON.stringify(JSON.parse(json), null, 2);
  } catch {
    return json;
  }
}

export default function IntegracaoExternaRawJson({ request, response }: IntegracaoExternaRawJsonProps) {
  const [expanded, setExpanded] = useState(false);

  if (!request && !response) return null;

  return (
    <div className="mt-4">
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
      >
        {expanded ? 'Ocultar JSON bruto' : 'Ver JSON bruto'}
      </Button>

      {expanded && (
        <Row className="mt-3">
          {request && (
            <Col md={6} className="mb-3">
              <Card>
                <Card.Header>Request</Card.Header>
                <Card.Body className="p-0">
                  <pre
                    style={{
                      maxHeight: '50vh',
                      overflow: 'auto',
                      background: '#f8f9fa',
                      padding: '10px',
                      margin: 0,
                      borderRadius: '0 0 4px 4px',
                    }}
                  >
                    {prettyJson(request)}
                  </pre>
                </Card.Body>
              </Card>
            </Col>
          )}
          {response && (
            <Col md={6} className="mb-3">
              <Card>
                <Card.Header>Response</Card.Header>
                <Card.Body className="p-0">
                  <pre
                    style={{
                      maxHeight: '50vh',
                      overflow: 'auto',
                      background: '#f8f9fa',
                      padding: '10px',
                      margin: 0,
                      borderRadius: '0 0 4px 4px',
                    }}
                  >
                    {prettyJson(response)}
                  </pre>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
      )}
    </div>
  );
}
